import { InputWithLabel } from '@adotel/components'
import { FormikErrors, FormikTouched } from 'formik'
import React from 'react'

import SectionTitle from '../../components/SectionTitle'
import { getTranslate } from '../../localization'
import { Accommodation } from '../../types/accommodation'

interface AccommodationContactDetailsProps {
  values: Accommodation
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  errors: FormikErrors<Accommodation>
  touched: FormikTouched<Accommodation>
  handleBlur: any
  isSubmitting: any
  classes: any
}

export const AccommodationContactDetails: React.FC<
  AccommodationContactDetailsProps
> = ({
  values,
  setFieldValue,
  errors,
  touched,
  handleBlur,
  isSubmitting,
  classes
}) => {
  return (
    <>
      <SectionTitle title="Contact Details" marginBottom />
      <div className={classes.fieldsContainer}>
        <InputWithLabel
          data-cy="contactDetailsEmail"
          name="contactDetails.email"
          label={getTranslate('General Email')}
          placeholder={getTranslate('Enter the accommodation general email')}
          autoComplete="off"
          value={values?.contactDetails?.email}
          onChange={(event) =>
            setFieldValue('contactDetails.email', event.currentTarget.value)
          }
          error={
            (touched.contactDetails?.email && !!errors.contactDetails?.email) ||
            undefined
          }
          helpertext={
            touched.contactDetails?.email
              ? getTranslate(errors.contactDetails?.email || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
        <InputWithLabel
          data-cy="contactDetailsBookingConfirmationEmail"
          name="contactDetails.bookingConfirmationEmail"
          label={getTranslate('Booking Email')}
          placeholder={getTranslate('Enter the accommodation booking email')}
          autoComplete="off"
          value={values?.contactDetails?.bookingConfirmationEmail}
          onChange={(event) =>
            setFieldValue(
              'contactDetails.bookingConfirmationEmail',
              event.currentTarget.value
            )
          }
          error={
            (touched.contactDetails?.bookingConfirmationEmail &&
              !!errors.contactDetails?.bookingConfirmationEmail) ||
            undefined
          }
          helpertext={
            touched.contactDetails?.bookingConfirmationEmail
              ? getTranslate(
                  errors.contactDetails?.bookingConfirmationEmail || ''
                )
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
        <InputWithLabel
          data-cy="contactDetailsBookingFailReportEmail"
          name="contactDetails.bookingFailReportEmail"
          label={getTranslate('Booking Fail Report Email')}
          placeholder={getTranslate(
            'Enter the accommodation email for booking fail reports'
          )}
          autoComplete="off"
          value={values?.contactDetails?.bookingFailReportEmail}
          onChange={(event) =>
            setFieldValue(
              'contactDetails.bookingFailReportEmail',
              event.currentTarget.value
            )
          }
          error={
            (touched.contactDetails?.bookingFailReportEmail &&
              !!errors.contactDetails?.bookingFailReportEmail) ||
            undefined
          }
          helpertext={
            touched.contactDetails?.bookingFailReportEmail
              ? getTranslate(
                  errors.contactDetails?.bookingFailReportEmail || ''
                )
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
        <InputWithLabel
          data-cy="contactDetailsBookingConfirmationPhoneNumber"
          name="contactDetails.bookingConfirmationPhoneNumber"
          label={getTranslate('General Phone Number')}
          placeholder={getTranslate('Enter the accommodation phone number')}
          autoComplete="off"
          value={values?.contactDetails?.bookingConfirmationPhoneNumber}
          onChange={(event) =>
            setFieldValue(
              'contactDetails.bookingConfirmationPhoneNumber',
              event.currentTarget.value
            )
          }
          error={
            (touched.contactDetails?.bookingConfirmationPhoneNumber &&
              !!errors.contactDetails?.bookingConfirmationPhoneNumber) ||
            undefined
          }
          helpertext={
            touched.contactDetails?.bookingConfirmationPhoneNumber
              ? getTranslate(
                  errors.contactDetails?.bookingConfirmationPhoneNumber || ''
                )
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
        <InputWithLabel
          data-cy="contactDetailsBookingFailReportPhoneNumber"
          name="contactDetails.bookingFailReportPhoneNumber"
          label={getTranslate('Booking Fail Report Phone Number')}
          placeholder={getTranslate('Enter the accommodation phone number')}
          autoComplete="off"
          value={values?.contactDetails?.bookingFailReportPhoneNumber}
          onChange={(event) =>
            setFieldValue(
              'contactDetails.bookingFailReportPhoneNumber',
              event.currentTarget.value
            )
          }
          error={
            (touched.contactDetails?.bookingFailReportPhoneNumber &&
              !!errors.contactDetails?.bookingFailReportPhoneNumber) ||
            undefined
          }
          helpertext={
            touched.contactDetails?.bookingFailReportPhoneNumber
              ? getTranslate(
                  errors.contactDetails?.bookingFailReportPhoneNumber || ''
                )
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
        <div />
        <InputWithLabel
          data-cy="contactDetailsFax"
          name="contactDetails.fax"
          label={getTranslate('General Fax Number')}
          placeholder={getTranslate('Enter the accommodation fax number')}
          autoComplete="off"
          value={values?.contactDetails?.fax}
          onChange={(event) =>
            setFieldValue('contactDetails.fax', event.currentTarget.value)
          }
          error={
            (touched.contactDetails?.fax && !!errors.contactDetails?.fax) ||
            undefined
          }
          helpertext={
            touched.contactDetails?.fax
              ? getTranslate(errors.contactDetails?.fax || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
        <InputWithLabel
          data-cy="contactDetailsBookingConfirmationFax"
          name="contactDetails.bookingConfirmationFax"
          label={getTranslate('Booking Confirmation Fax Number')}
          placeholder={getTranslate(
            'Enter the accommodation booking confirmation fax number'
          )}
          autoComplete="off"
          value={values?.contactDetails?.bookingConfirmationFax}
          onChange={(event) =>
            setFieldValue(
              'contactDetails.bookingConfirmationFax',
              event.currentTarget.value
            )
          }
          error={
            (touched.contactDetails?.bookingConfirmationFax &&
              !!errors.contactDetails?.bookingConfirmationFax) ||
            undefined
          }
          helpertext={
            touched.contactDetails?.bookingConfirmationFax
              ? getTranslate(
                  errors.contactDetails?.bookingConfirmationFax || ''
                )
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
      </div>
    </>
  )
}
